import * as Yup from "yup";

export const credentialFormValidation = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  applicationType: Yup.string().required("Application type is required")
});
